const renderOptions = item => {
  return {
    label: item.label,
    value: item.value,
  }
}
const renderFormInput = (props, userRenderProp) => {
  const { statuses, team, costCenters } = props
  const costCentersOptions = [...costCenters]
  // to remove 'Select Cost Center' placeholder option
  const formInput = [
    [
      {
        name: 'teamName',
        columnType: {
          lg: '4',
        },
        defaultValue: team?.name || '',
        disabled: false,
        customClassName: 'pr-1',
        customDataTestId: 'qa-team-name-input',
      },
      {
        name: 'costCenter',
        columnType: {
          lg: '4',
        },
        type: 'select',
        defaultValue: team?.costCentreId || '',
        options: costCentersOptions,
        customClassName: 'pr-1',
        customDataTestId: 'qa-costcenter-dropdown',
      },
      {
        name: 'status',
        columnType: {
          lg: '4',
        },
        type: 'select',
        defaultValue: team?.status || '',
        options: statuses.map(renderOptions),
        customClassName: 'pr-1',
        customDataTestId: 'qa-status-dropdown',
      },
    ],
    [
      // {
      //   name: 'teamNames',
      //   columnType: {
      //     lg: '4',
      //   },
      //   customClassName: 'px-2',
      //   RenderProps: userRenderProp,
      // },
      {
        name: 'description',
        placeholderKey: 'descriptionPlaceholder',
        type: 'textarea',
        className: 'h-100',
        defaultValue: team?.description || '',
        columnType: {
          lg: '8',
        },
        customClassName: 'd-flex flex-column pr-1',
        customDataTestId: 'qa-team-description-input',
      },
    ],
  ]

  return formInput
}

export { renderFormInput }
